import React, {
    useEffect,
    useContext,
    useState,
} from "react"

import TaskRatingsVM from "../ViewModel/TaskRatings.vm"

import {
    Context,
} from "../Model/Contexts/AppContext"

const TaskRatings = () => {
    /*
     * Deconstruct all props using destructuring assignment
     * Model the props for each view in the ViewModel using a ts type
     * Add a props parameter of type "TaskRatingsProps" above.
     *
     * Most variables will be available in context or the view model.
     * Consume and destructure all needed context variables:
     */

    const {
        user,
    } = useContext(Context)

    const [_data, setData] = useState({})

    const load = async () => {
        // Use the view model functions to load data and return it (await)
        // Access state variables the user may have changed and

        return {}
    }

    const _init = async () => {
        const d = await load()
        setData(d)
    }

    const _refresh = async () => {
        await _init()
        // Set additional state variables here...
    }

    useEffect(() => {
        if (user)
            TaskRatingsVM.user = user

        _init()
    }, [user])

    return (
        <div
            id="taskratings"
        >
            The Task Ratings view is still under development. Please check back for version v1.0.1 on October 10, 2025.
        </div>
    )
}

export default TaskRatings
